import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/system';

import { HALF_WIDTH, FULL_WIDTH } from 'bento-ordering/base/constants/grid';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const GridItem = styled(Grid, {
  shouldForwardProp: muiPropForwarding('isMediumAndUp', 'index')
})(({ isMediumAndUp, index }) => {
  const styles = {
    marginBottom: '14px'
  };

  if (isMediumAndUp) {
    if (index % 2 === 0) {
      styles.paddingRight = '12px';
    } else {
      styles.paddingLeft = '12px';
    }
  }

  return {
    '&.MuiGrid-item': styles
  };
});

const TWO_COL_GRID_ITEM = {
  md: HALF_WIDTH,
  sm: FULL_WIDTH,
  xs: FULL_WIDTH
};
const MenuSectionGrid = ({ children }) => {
  const theme = useTheme();
  const isMediumAndUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Grid container component={List}>
      {children.map((child, idx) => {
        return (
          <GridItem
            item
            key={child.props.id}
            {...TWO_COL_GRID_ITEM}
            component={ListItem}
            isMediumAndUp={isMediumAndUp}
            index={idx}
          >
            {child}
          </GridItem>
        );
      })}
    </Grid>
  );
};

MenuSectionGrid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default MenuSectionGrid;
